import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as styles from './Carousel.scss';

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.autoplay) {
        setInterval(function () {
          _this.nextSlide();
        }, _this.props.slideTime);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "prevSlide", function () {
      var prevSlide = _this.state.counter - 1 < 0 ? _this.props.slides.length - 1 : _this.state.counter - 1;

      _this.setState({
        counter: prevSlide
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextSlide", function () {
      console.log('this.state.counter');
      console.log(_this.state.counter);
      console.log(_this.props.slides.length);
      console.log('this.props.slides.length');
      var nextSlide = _this.state.counter + 1 < _this.props.slides.length ? _this.state.counter + 1 : 0;

      _this.setState({
        counter: nextSlide
      });
    });

    _this.state = {
      counter: 0
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      var style = {
        backgroundImage: "url(".concat(this.props.slides[this.state.counter], ")"),
        paddingBottom: this.props.paddingBottom
      };
      return /*#__PURE__*/React.createElement("div", {
        style: {
          overflow: 'hidden',
          flex: '0 0 auto',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          display: 'inline-block',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        transitionName: 'slidein-enter',
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 500,
        component: "div",
        className: styles.carouselSlideWrap,
        transitionAppear: this.props.appearTransition,
        transitionAppearTimeout: 1000
      }, /*#__PURE__*/React.createElement("div", {
        style: style,
        className: styles.carouselSlide,
        key: this.state.counter
      })));
    }
  }]);

  return Carousel;
}(React.Component);

_defineProperty(Carousel, "propTypes", {
  organization: PropTypes.object.isRequired,
  transition: PropTypes.string,
  appearTransition: PropTypes.bool
});

_defineProperty(Carousel, "defaultProps", {
  autoplay: true,
  transition: 'blur',
  appearTransition: true,
  slideTime: 5000,
  slides: ['https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?fit=crop&fm=jpg&h=825&q=80&w=1325', 'https://images.unsplash.com/photo-1445251836269-d158eaa028a6?fit=crop&fm=jpg&h=825&q=80&w=1325', 'https://images.unsplash.com/photo-1443926818681-717d074a57af?fit=crop&fm=jpg&h=825&q=80&w=1325'],
  paddingBottom: '37%'
});

export default Carousel;